import store from '../store/Store';
import { InboxClassificationFilter } from 'owa-mail-list-store';

export default function isFocusedOtherPivotsEnabled(): boolean {
    for (const pivot of store.enabledDisabledPivots) {
        if (
            (pivot.InboxClassificationFilter === InboxClassificationFilter.Focused ||
                pivot.InboxClassificationFilter === InboxClassificationFilter.Other) &&
            pivot.isEnabled
        ) {
            return true;
        }
    }

    return false;
}
